import { render, staticRenderFns } from "./inspection-charts.vue?vue&type=template&id=20418cc7&scoped=true&"
import script from "./inspection-charts.vue?vue&type=script&lang=js&"
export * from "./inspection-charts.vue?vue&type=script&lang=js&"
import style0 from "./inspection-charts.vue?vue&type=style&index=0&id=20418cc7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20418cc7",
  null
  
)

export default component.exports